export const makeSelectChartData = (state) => state.chart.chartData;
export const makeSelectMasterData = (state) => state.chart.masterData;
